module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "interactions-tab-container",
      "element-loading-background": "#F7F8FC"
    }
  }, _vm._l((_vm.interactions), function(interaction) {
    return _c('el-card', {
      key: interaction.id,
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('message', {
      key: interaction.id,
      staticClass: "message",
      class: {
        'first-message': interaction.id === _vm.firstInteractionId
      },
      attrs: {
        "audio": _vm.getOreValues(interaction, 'audio').value,
        "avatar": _vm.getOreValue(interaction, 'profile_image', null),
        "comments": interaction.comments,
        "channel": interaction.type,
        "displayName": _vm.getOreValue(interaction, 'display_name')[0] || '',
        "datetime": _vm.moment(interaction.date_created),
        "datetimeIsChanged": _vm.datetimeIsChanged,
        "images": _vm.getOreValues(interaction, 'image').value,
        "id": interaction.id,
        "isOnAir": _vm.type === 'onair',
        "message": _vm.getOreValue(interaction, 'message'),
        "originator": _vm.getOreValue(interaction, 'originators'),
        "originatorType": _vm.getOreValues(interaction, 'originators').type[0],
        "onAirUsers": _vm.onAirUsers,
        "parentInteraction": interaction.parent,
        "replies": interaction.replies,
        "video": _vm.getOreValues(interaction, 'video').value,
        "showTools": false,
        "autoCollapseParentInteraction": true
      },
      on: {
        "changeDatetimePostFormat": _vm.changeDateFormat
      }
    })], 1)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f82357c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profiles/profile/tabs/InteractionsTab.vue
// module id = 3327
// module chunks = 3